import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useCategories() {
  const [categories, setCategories] = useState([]);
  const reload = useCallback(() => api.get("/categories").then((r) => setCategories(r.data)).catch(() => {}), []);
  useEffect(() => {
    reload();
  }, [reload]);
  const labels = Object.fromEntries(categories.map((c) => [c.key, c.label]));
  return { categories, labels, reload };
}
